var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-social-container"},[_c('a',_vm._g(_vm._b({staticClass:"button-social"},'a',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('n-icon',{attrs:{"name":_vm.icon,"color":"grey-dark"}}):_c('div',{staticClass:"circle"}),_c('n-text',{attrs:{"preset":"body"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }